export default __webpack_public_path__ + "static/media/skully-img.daceb059.png";